
import moment from "moment";
import webConfig from "@/config/web.config";
import keywordConfig from "@/config/onboarding.config/keyword.json"
import router from "@/router";
import webLanguage from "@/config/language/webLanguage"
import mainConfig from "@/config/onboarding.config/main.json"
import Vue from "vue";
const utils = {
    initFt: 30.48,
    initIn: 2.54,
    initLbs: 0.45359237,
    initUnderweight: 18.5,
    initNormal: 25,
    initOverweight: 30,

    //禁用浏览器返回事件
    disableBrowserBack() {
        history.pushState(null, null, window.location.href);
    },
    // 监听输入框value变化
    inputValueWatch(newValue, oldValue, maxNumber = 9) {
        if (newValue == '') return 0
        if (oldValue == 0) newValue = newValue * 1
        let res = 0
        let str = (newValue + '').split('.');
        if ((newValue + '').includes('.')) {
            res = oldValue

        } else {
            res = Number(newValue) > maxNumber ? oldValue : newValue
        }
        return res
    },
    //数字格式化：有小数点取到小数点 ，整数不显示小数点
    formatNumber(num, fixedNumber = 1) {
        if (num) {
            num = num * 1;
            num = num.toFixed(fixedNumber);
            return num % 1 === 0 ? Math.round(num) : num;
        }
        return 0
    },

    // kg转英镑
    kgToLbs(kg, min = 0, max = 0, number = 1) {

        if (!kg) return 0;
        let res = utils.formatNumber((kg / utils.initLbs), number);
        if (min && res < min) {
            res = min
        }
        if (max && res > max) {
            res = max
        }
        return res
    },
    // 英镑转kg
    lbsToKg(lbs, min = 0, max = 0, number = 1) {

        if (!lbs) return 0;
        let res = utils.formatNumber((utils.initLbs * lbs), number);
        if (min && res < min) {
            res = min
        }
        if (max && res > max) {
            res = max
        }
        return res
    },
    // 时间格式化
    getDate(date, format = "MM/DD/YYYY") {
        if (!date) return '';
        moment.locale(Vue.prototype.$language);
        return moment(date).format(format)
    },
    // 时间戳转格式
    formattedDate(timestamp, format = 'MMM DD,YYYY') {
        if (!timestamp) return
        return moment(timestamp).format(format);
    },
    // 日期转时间戳
    formatTimestamp(date) {
        if (!date) return
        date = moment(date);
        // 转换为时间戳（毫秒）
        return date.valueOf();
    },
    // 两个时间日期的时间差（毫秒差）
    momentDifference(time1, time2, unit = '') {
        time1 = moment(time1)
        time2 = moment(time2)
        return time2.diff(time1, unit); // 默认返回毫秒
    },
    //计算num个月后的时间
    getAnyMonth(n, format = "MM/DD/YYYY") {
        const now = moment();
        return utils.getDate(now.add(n, 'months'), format)
    },
    // 获取n天后的日期
    getAnyDay(n, format = "MM/DD/YYYY") {
        const today = new Date();
        today.setDate(today.getDate() + n);
        return utils.getDate(today, format);
    },
    //获取bmi值：BMI=体重(kg)/身高(m)^2
    calculateBMI(height, weight) {
        if (height > 0 && weight > 0) {
            const heightInMeters = height / 100; // 将身高转换为米
            const bmi = weight / (heightInMeters ** 2);
            return utils.formatNumber(bmi);
        }
        return '';
    },
    // 邮箱格式验证
    emailValidate(email) {
        let reg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/
        return reg.test(email)
    },
    //密码验证
    passwordValidate(password) {
        let reg = /^(?=.*[a-zA-Z])(?=.*\d).{8,30}$/
        return reg.test(password)
    },
    //首字母转大写
    apitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
    // 文本替换关键词
    redirectUrlKeyword(str) {
        str = utils.getAppName(str);
        // 获取当前关键字，默认为默认关键字
        let k = router.currentRoute.query.k || webConfig.defaultUrlKeyword;
        const whiteList = webConfig.urlKeywordWhitelist;
        // 如果当前关键字不在白名单中，使用默认关键字
        k = whiteList.includes(k) ? k : webConfig.defaultUrlKeyword;
        if (webLanguage === 'en') {
            // 查找匹配的项
            const matchedKeyword = keywordConfig.keywordList.find(item => item.k === String(k));
            str = str.replace(/\$\{(\w+)\}/g, (match, p1) => matchedKeyword[p1] || '');
        } else {
            let newUrlKeyword = keywordConfig[webLanguage][k];
            str = str.replace(/\${keyword[1-4]}/g, newUrlKeyword);
        }
        return str;
    },
    capitalizeFirstLetter(str) {
        if (!str) return '';
        return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    // 用于处理介词保持小写的首字母大写逻辑
    capitalizeWithPrepositions(str, prepositions) {
        return str.split(' ').map((word, index) => {
            if (index === 0 || !prepositions.includes(word)) {
                return word.charAt(0).toUpperCase() + word.slice(1);
            }
            return word.toLowerCase();
        }).join(' ');
    },
    getUrlParams(url) {
        let pattern = /([\w%]+)=([^&]+)/g; // 修改正则表达式以支持特殊字符
        let parames = {}; // 定义参数对象
        url.replace(pattern, ($, $1, $2) => {
            parames[$1] = $2;
        });
        return parames;
    },
    // 自定义路由跳转
    routerReplace(path, params) {
        utils.customRouterNavigate(path, true, params);
    },
    routerPush(path, params) {
        utils.customRouterNavigate(path, false, params);
    },
    //路由跳转
    customRouterNavigate(path, replace, params = {}) {
        //除当前路由外移除当前url参数
        const pathObj = {
            policyType: '/policy-page',
            paymentSuccess: '/create-account-page',
            isPay: '/paywall-page'
        }
        const urlParams = utils.getUrlParams(window.location.href);
        console.log(urlParams);
        let query = JSON.parse(window.sessionStorage.getItem('urlQuery')) || {};
        query = Object.assign(query, urlParams, params);
        for (let key in pathObj) {
            if (pathObj[key] != path) {
                delete query[key];
            }
        }
        if (path == '/user-profile-page' && query.chooseAProgram) {
            delete query.chooseAProgram;
            delete query.uid;
        }
        if (replace) {
            router.replace({
                path,
                query,
            })
        } else {
            router.push({
                path,
                query,
            })
        }
    },
    getAppName(str) {
        return str = str.replace(/\${appName}/g, mainConfig.appName);//全大写 空格
    },
    //文本替换变量
    replaceTextValue(str, value1, value2, value3, value4) {
        //str:文本 value1:数量 value2:周期（周/月） value3:原价 value4:支付的价格
        str = str.replace(/\${keyword1}/g, value1);//全大写 空格
        str = str.replace(/\${keyword2}/g, value2);// 第一个字母大写 空格
        str = str.replace(/\${keyword3}/g, value3);// 全小写 空格
        str = str.replace(/\${keyword4}/g, value4); // 全首字母大写 空格
        return str
    },
    replaceMetaKeyword(str, urlKeyword) {
        let whiteList = webConfig.urlKeywordWhitelist;
        if (!whiteList.includes(urlKeyword)) {
            urlKeyword = webConfig.defaultUrlKeyword;
        }
        let newUrlKeyword = urlKeyword.replace(/([A-Z])/g, ' $1').toLowerCase();
        newUrlKeyword = newUrlKeyword.slice(1);
        str = str.replace(/\${keyword1}/g, newUrlKeyword.toUpperCase());//全大写 空格
        str = str.replace(/\${keyword2}/g, utils.apitalizeFirstLetter(newUrlKeyword));// 第一个字母大写 空格
        str = str.replace(/\${keyword3}/g, newUrlKeyword.toLowerCase()); // 全小写 空格
        str = str.replace(/\${keyword4}/g, newUrlKeyword.toLowerCase().replace(/( |^)[a-z]/g, (L) => L.toUpperCase())); // 全首字母大写 空格
        return str
    },
    // 获取映射表别名
    getKey(key) {
        return webConfig.onBoardingKey[key] ? webConfig.onBoardingKey[key] : key
    },
    getDisplayWeight(weight, weightUnit) {
        const { weightType, weightKgUnitNumber } = webConfig;
        let convertedWeight;
        // 判断当前单位是否是 kg
        if (weightUnit === weightKgUnitNumber) {
            // 如果存储的值类型是 kg，直接使用 weight，否则将 lbs 转换为 kg
            convertedWeight = weightType === 0 ? weight : utils.lbsToKg(weight);
        } else {
            // 如果单位是 lbs，且存储的值类型是 kg，则将 kg 转换为 lbs，否则直接使用 weight
            convertedWeight = weightType === 0 ? utils.kgToLbs(weight) : weight;
        }
        // 根据传入的单位决定后缀是 'kg' 还是 'lbs'
        const unitLabel = weightUnit === weightKgUnitNumber ? 'kg' : 'lbs';
        return `${convertedWeight}${unitLabel}`;
    },
    //生成16位uuid
    generateUUID() {
        return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            const r = (Math.random() * 16) | 0;
            const v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    },
    // 设置 body 的 overflow 设置方法
    setBodyOverflow(value) {
        document.body.style.overflow = value;
    },
    // 模版图片预加载
    templateImgLoad(config, fileName = '') {

        let imgList = [];
        // 合并 mainImage 和 imageList
        if (config.mainImage) {
            imgList.push(config.mainImage);
        }
        if (Array.isArray(config.imageList) && config.imageList.length) {
            imgList = imgList.concat(config.imageList);  // 直接合并
        }
        // 如果有图片列表则加载
        imgList.forEach((imgName) => {
            try {
                const src = require(`@/assets/image/template/${fileName}${imgName}`); // 使用 require 动态加载
                const image = new Image();
                image.src = src;
            } catch (error) {
                console.error(`Failed to load image: ${imgName}`, error); // 错误处理
            }
        });
    },
    //模版选项分组图片预加载
    allTemplateImgLoad(config, fileName = '') {
        for (const key in config) {
            const templateConfig = config[key];
            if (templateConfig && templateConfig.screenName) {
                utils.templateImgLoad(templateConfig, fileName);
            }

        }
        utils.templateImgLoad(config, fileName = '');// 加载默认分组
    },

    // 同步延迟等待
    sleep(ms = 3000) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    },
    //价格分组ab测试：文档链接：https://laientech.feishu.cn/wiki/NrT1whEPvikbjjkbTzecBuQ2n7f?from=from_copylink
    getPriceGroup(priceGroup) {
        const priceGroupWhiteList = webConfig.priceGroupWhiteList; // 价格分组白名单
        const defaultPriceGroup = webConfig.defaultPriceGroup; // 默认价格分组
        return priceGroupWhiteList.includes(priceGroup) ? priceGroup : defaultPriceGroup;
    },
    //价格分组ab测试埋点
    getMixpanelPriceGroup(priceGroup) {
        const mixpanelPriceGroupWhiteList = webConfig.mixpanelPriceGroupWhiteList; // 价格分组白名单
        const defaultMixpanelPriceGroup = webConfig.defaultMixpanelPriceGroup; // 默认价格分组
        return mixpanelPriceGroupWhiteList.includes(priceGroup) ? priceGroup : defaultMixpanelPriceGroup;
    },

    //获取折扣比例 临时定义 后面由后端管理
    getDiscount(type) {
        const { lpid } = utils.getUrlParams(window.location.href);
        const priceGroup = utils.getPriceGroup(lpid)
        // 折扣比例映射表
        const discountMap = {
            "9BKFW": { discount: "61%", furtherDiscount: "71%" },
            "UK83Q": { discount: "71%", furtherDiscount: "81%" },
            "O2MGB": { discount: "81%", furtherDiscount: "91%" }
        };
        // 返回对应的折扣比例
        return discountMap[priceGroup][type];
    },
    // 处理用户选择，找到匹配的规则并展示对应选项文案
    processLastSelection(lastSelectedOptions, currentScreenName, templateData) {
        if (!Array.isArray(lastSelectedOptions)) {
            lastSelectedOptions = [lastSelectedOptions]; // 如果是单选转为数组形式
        }
        const selectedSet = new Set(lastSelectedOptions);
        const questionRules = mainConfig.TextVariationRules?.[currentScreenName];
        if (!questionRules) return templateData;
        // 遍历规则，找到第一个匹配的规则
        const matchingRule = questionRules.find(rule => {
            return rule.conditions.some(conditionSet => {
                // 转换条件集合
                const conditionSetObj = new Set(conditionSet);
                // 判断是否精确匹配
                return conditionSetObj.size === selectedSet.size &&
                    [...conditionSetObj].every(item => selectedSet.has(item));
            });
        });
        console.log(matchingRule?.nextTextVariation);

        // 输出匹配结果
        return templateData?.[matchingRule?.nextTextVariation] || templateData;
    }








}
export default utils